import { PERIOD } from '../../constants/shared/CommonConstants';
import { getMeasuresByGrade } from './gradeToMeasureUtils';
import { MEASURE } from '../../constants/shared/MeasuresConstants';
import { GRADE } from '../../constants/shared/GradesConstants';

const { BOY, MOY, EOY, SUMMER } = PERIOD;
const { SPELLING } = MEASURE;
const { KINDERGARTEN } = GRADE;

export const getAvailablePeriods = currentPeriod => {
    switch (currentPeriod) {
        case BOY:
            return [BOY];
        case MOY:
            return [BOY, MOY];
        case EOY:
            return [BOY, MOY, EOY];
        default:
            return [BOY, MOY, EOY, SUMMER];
    }
};

export const getPercentageSign = (percentageMeasures = [], measureKey = '') =>
    percentageMeasures.includes(measureKey) ? '%' : '';

export const buildColSpan = (row, { columnStartIndex, columnStopIndex }, child, customStyle) => ({
    row,
    columnStartIndex,
    columnStopIndex,
    child,
    customStyle,
});

export const hasMeasureGradeNoExceptions = (measureKey, grade, period) =>
    !(measureKey === SPELLING && grade === KINDERGARTEN && period === BOY);

export const isMeasureEnabledForSpecificMapper = (
    measureKey,
    grade,
    period,
    gradeToMeasureMapper,
) =>
    hasMeasureGradeNoExceptions(measureKey, grade, period) &&
    getMeasuresByGrade(gradeToMeasureMapper, grade).includes(measureKey);
